import styled from 'styled-components/native';

import Text from '@components/Text';

export const Container = styled.View`
  justify-content: center;
  align-items: center;

  margin-top: 54px;
`;

export const WithoutInvoiceImage = styled.Image`
  width: 198px;
  height: 105px;
`;

export const WithoutInvoiceTitle = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[500]};
  color: ${props => props.theme.colors.grayscale.slot6};
  padding-top: 40px;
  text-align: center;
`;

export const WithoutInvoiceSubtitle = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[400]};
  color: ${props => props.theme.colors.grayscale.slot6};
  padding-top: 8px;
  text-align: center;
  max-width: 256px;
`;
